var _style, _title, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _path11, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudiodrillzLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b1aa67b9-718e-490b-b6ab-9ec7bc7260a8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 66 12",
    style: {
      enableBackground: "new 0 0 66 12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n\t.st7{fill:url(#SVGID_8_);}\n\t.st8{fill:url(#SVGID_9_);}\n\t.st9{fill:url(#SVGID_10_);}\n\t.st10{fill:url(#SVGID_11_);}\n\t.st11{fill:url(#SVGID_12_);}\n\t.st12{fill:url(#SVGID_13_);}\n")), /*#__PURE__*/React.createElement("g", null, _title || (_title = /*#__PURE__*/React.createElement("title", null, "AudiodrillzLogo")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.2953,
    y1: 7.0223,
    x2: 65.2952,
    y2: 7.8557,
    gradientTransform: "matrix(1 0 0 -1 0 13.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00381,
    style: {
      stopColor: "#FF638A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4634,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6426,
    style: {
      stopColor: "#A0DF39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8181,
    style: {
      stopColor: "#4AF06D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9406,
    style: {
      stopColor: "#15FB8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FF9A"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.1,0.8c0.1,0,0.2,0,0.3,0.1s0.2,0.2,0.2,0.3l3.2,9.3c0,0.1,0,0.2,0,0.2c0,0.1,0,0.2-0.1,0.3 s-0.2,0.1-0.4,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.1-0.2-0.2L6,8.4H2.1l-0.8,2.5c0,0.1-0.1,0.2-0.2,0.2 c-0.1,0.1-0.2,0.1-0.3,0.1s-0.3,0-0.4-0.1s-0.1-0.2-0.1-0.4c0-0.1,0-0.1,0-0.2l3.2-9.3c0-0.1,0.1-0.2,0.2-0.3S3.9,0.8,4.1,0.8z  M2.4,7.5h3.3L4.1,2.3L2.4,7.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.316,
    y1: 5.5091,
    x2: 65.316,
    y2: 6.3424,
    gradientTransform: "matrix(1 0 0 -1 0 13.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00381,
    style: {
      stopColor: "#FF638A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4634,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6426,
    style: {
      stopColor: "#A0DF39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8181,
    style: {
      stopColor: "#4AF06D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9406,
    style: {
      stopColor: "#15FB8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FF9A"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.5,3.6c0.1,0,0.3,0,0.4,0.1C15,3.8,15,3.9,15,4.1v6.1c0,0.3-0.2,0.5-0.5,0.6c-0.4,0.1-0.7,0.2-1.1,0.3 c-0.4,0.1-0.7,0.1-1.1,0.1c-0.9,0-1.6-0.2-2-0.7s-0.7-1.1-0.7-2V4.1c0-0.1,0-0.3,0.1-0.4c0.1,0,0.3-0.1,0.4-0.1s0.3,0,0.3,0.1 c0.1,0.1,0.1,0.2,0.1,0.4v4.5c0,0.5,0.1,0.9,0.4,1.2s0.7,0.4,1.3,0.4c0.3,0,0.6,0,0.9-0.1c0.3,0,0.6-0.1,0.8-0.2V4.1 c0-0.1,0-0.3,0.1-0.4C14.2,3.7,14.3,3.6,14.5,3.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.299,
    y1: 6.8335,
    x2: 65.299,
    y2: 7.6668,
    gradientTransform: "matrix(1 0 0 -1 0 13.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00381,
    style: {
      stopColor: "#FF638A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4634,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6426,
    style: {
      stopColor: "#A0DF39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8181,
    style: {
      stopColor: "#4AF06D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9406,
    style: {
      stopColor: "#15FB8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FF9A"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.3,0.8c0.1,0,0.3,0,0.3,0.1c0.1,0.1,0.1,0.2,0.1,0.4v9c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.2,0.2-0.3,0.2 c-0.4,0.1-0.7,0.2-1.1,0.3s-0.8,0.1-1.1,0.1c-0.8,0-1.4-0.2-1.9-0.7c-0.5-0.4-0.7-1.1-0.7-2V6.2c0-0.4,0.1-0.8,0.2-1.1 c0.1-0.3,0.3-0.6,0.5-0.8C18.4,4.2,18.7,4,19,3.9s0.7-0.2,1-0.2s0.6,0,0.9,0.1s0.6,0.2,0.9,0.4v-3c0-0.1,0-0.3,0.1-0.4 C22,0.8,22.2,0.8,22.3,0.8z M20.1,4.6c-0.5,0-1,0.1-1.3,0.4s-0.4,0.7-0.4,1.2v2.4c0,0.5,0.1,0.9,0.4,1.2s0.7,0.4,1.3,0.4 c0.3,0,0.6,0,0.9-0.1c0.3,0,0.6-0.1,0.8-0.2V5.2c-0.2-0.2-0.5-0.4-0.8-0.5C20.7,4.7,20.4,4.6,20.1,4.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.3011,
    y1: 6.5702,
    x2: 65.3011,
    y2: 7.4035,
    gradientTransform: "matrix(1 0 0 -1 0 13.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00381,
    style: {
      stopColor: "#FF638A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4634,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6426,
    style: {
      stopColor: "#A0DF39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8181,
    style: {
      stopColor: "#4AF06D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9406,
    style: {
      stopColor: "#15FB8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FF9A"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26,1.2c0.2,0,0.3,0.1,0.4,0.2s0.2,0.3,0.2,0.4c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.3,0.2-0.4,0.2 c-0.2,0-0.3-0.1-0.4-0.2s-0.2-0.3-0.2-0.4c0-0.2,0.1-0.3,0.2-0.4C25.7,1.3,25.8,1.2,26,1.2z M26,3.8c0.1,0,0.3,0,0.3,0.1 c0.1,0.1,0.1,0.2,0.1,0.4v6.5c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.3,0-0.4-0.1s-0.1-0.2-0.1-0.4V4.3 c0-0.1,0-0.3,0.1-0.4C25.7,3.9,25.8,3.8,26,3.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.3187,
    y1: 5.1973,
    x2: 65.3186,
    y2: 6.0307,
    gradientTransform: "matrix(1 0 0 -1 0 13.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00381,
    style: {
      stopColor: "#FF638A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4634,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6426,
    style: {
      stopColor: "#A0DF39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8181,
    style: {
      stopColor: "#4AF06D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9406,
    style: {
      stopColor: "#15FB8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FF9A"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M31.7,3.8c0.9,0,1.6,0.2,2.1,0.7s0.7,1.2,0.7,2.1v2c0,0.9-0.2,1.5-0.7,2s-1.2,0.7-2.1,0.7 c-0.9,0-1.5-0.2-2-0.7s-0.8-1.2-0.8-2v-2c0-0.9,0.3-1.6,0.8-2.1C30.1,4.1,30.8,3.8,31.7,3.8z M31.7,4.7c-0.5,0-1,0.2-1.3,0.5 S29.9,6,29.9,6.5v2.1c0,0.6,0.2,1,0.5,1.3c0.3,0.3,0.8,0.5,1.3,0.5s1-0.2,1.3-0.5s0.5-0.8,0.5-1.3V6.5c0-0.6-0.2-1-0.5-1.3 C32.7,4.9,32.2,4.7,31.7,4.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.3021,
    y1: 6.5874,
    x2: 65.3022,
    y2: 7.4207,
    gradientTransform: "matrix(1 0 0 -1 0 13.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00381,
    style: {
      stopColor: "#FF638A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4634,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6426,
    style: {
      stopColor: "#A0DF39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8181,
    style: {
      stopColor: "#4AF06D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9406,
    style: {
      stopColor: "#15FB8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FF9A"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M41.5,0.8c0.1,0,0.3,0,0.3,0.1c0.1,0.1,0.1,0.2,0.1,0.4v9c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.2,0.2-0.3,0.2 c-0.4,0.1-0.7,0.2-1.1,0.3s-0.8,0.1-1.1,0.1c-0.8,0-1.4-0.2-1.9-0.7c-0.5-0.4-0.7-1.1-0.7-2V6.2c0-0.4,0.1-0.8,0.2-1.1 c0.1-0.3,0.3-0.6,0.5-0.8c0.2-0.2,0.5-0.4,0.8-0.5s0.7-0.2,1-0.2s0.6,0,0.9,0.1C40.4,3.8,40.7,4,41,4.2v-3c0-0.1,0-0.3,0.1-0.4 C41.3,0.8,41.4,0.8,41.5,0.8z M39.4,4.6c-0.5,0-1,0.1-1.3,0.4s-0.4,0.7-0.4,1.2v2.4c0,0.5,0.1,0.9,0.4,1.2s0.7,0.4,1.3,0.4 c0.3,0,0.6,0,0.9-0.1c0.3,0,0.6-0.1,0.8-0.2V5.2c-0.3-0.2-0.5-0.4-0.8-0.5S39.7,4.6,39.4,4.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.05462238,
    y1: 4.9644,
    x2: 64.9454,
    y2: 5.7978,
    gradientTransform: "matrix(1 0 0 -1 0 13.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00381,
    style: {
      stopColor: "#FF638A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4634,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6426,
    style: {
      stopColor: "#A0DF39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8181,
    style: {
      stopColor: "#4AF06D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9406,
    style: {
      stopColor: "#15FB8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FF9A"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M46.3,3.8c0.4,0,0.7,0,1,0.1s0.4,0.2,0.4,0.5c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1s-0.2,0-0.4-0.1 c-0.1,0-0.3-0.1-0.6-0.1s-0.5,0.1-0.7,0.3s-0.3,0.5-0.3,0.8v5c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1,0-0.2,0-0.3-0.1 s-0.1-0.2-0.1-0.4v-5c0-0.6,0.2-1.1,0.5-1.4C45.2,4,45.7,3.8,46.3,3.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.1218,
    y1: 6.2561,
    x2: 65.1217,
    y2: 7.0894,
    gradientTransform: "matrix(1 0 0 -1 0 13.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00381,
    style: {
      stopColor: "#FF638A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4634,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6426,
    style: {
      stopColor: "#A0DF39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8181,
    style: {
      stopColor: "#4AF06D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9406,
    style: {
      stopColor: "#15FB8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FF9A"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M50.3,1.2c0.2,0,0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.3,0.2,0.4c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.3,0.2-0.4,0.2 c-0.2,0-0.3-0.1-0.4-0.2s-0.2-0.3-0.2-0.4c0-0.2,0.1-0.3,0.2-0.4C49.9,1.3,50.1,1.2,50.3,1.2z M50.3,3.8c0.1,0,0.3,0,0.3,0.1 c0.1,0.1,0.1,0.2,0.1,0.4v6.5c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.2,0.1-0.3,0.1s-0.3,0-0.4-0.1s-0.1-0.2-0.1-0.4V4.3 c0-0.1,0-0.3,0.1-0.4C50,3.9,50.1,3.8,50.3,3.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.2832,
    y1: 4.6178,
    x2: 65.2832,
    y2: 5.4512,
    gradientTransform: "matrix(1 0 0 -1 0 13.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00381,
    style: {
      stopColor: "#FF638A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4634,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6426,
    style: {
      stopColor: "#A0DF39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8181,
    style: {
      stopColor: "#4AF06D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9406,
    style: {
      stopColor: "#15FB8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FF9A"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M65.1,4c0.2,0,0.3,0.1,0.4,0.2s0.2,0.2,0.2,0.4c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.2l-3.7,5.4h3.4 c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.1,0.2,0.1,0.3s0,0.2-0.1,0.3s-0.2,0.1-0.3,0.1h-4.2c-0.2,0-0.3-0.1-0.4-0.2 c-0.1-0.1-0.2-0.2-0.2-0.4c0-0.1,0-0.1,0-0.2c0-0.1,0.1-0.1,0.1-0.2l3.7-5.3H61c-0.1,0-0.3,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3 s0-0.2,0.1-0.3s0.2-0.1,0.3-0.1h4.1V4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.221,
    y1: 6.3124,
    x2: 65.221,
    y2: 7.1457,
    gradientTransform: "matrix(1 0 0 -1 0 13.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00381,
    style: {
      stopColor: "#FF638A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4634,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6426,
    style: {
      stopColor: "#A0DF39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8181,
    style: {
      stopColor: "#4AF06D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9406,
    style: {
      stopColor: "#15FB8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FF9A"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M57.7,0.9c0.1,0,0.3,0,0.4,0.1c0.1,0.1,0.1,0.2,0.1,0.4v9.4c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.2,0.1-0.4,0.1 c-0.1,0-0.2,0-0.3-0.1s-0.1-0.2-0.1-0.4V1.4c0-0.1,0-0.3,0.1-0.4S57.6,0.9,57.7,0.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.2505,
    y1: 7.7124,
    x2: 65.2505,
    y2: 8.5457,
    gradientTransform: "matrix(1 0 0 -1 0 13.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00381,
    style: {
      stopColor: "#FF638A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4634,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6426,
    style: {
      stopColor: "#A0DF39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8181,
    style: {
      stopColor: "#4AF06D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9406,
    style: {
      stopColor: "#15FB8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FF9A"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 57.8,
    cy: 4.7,
    r: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.01211383,
    y1: 6.3588,
    x2: 65.0121,
    y2: 7.1921,
    gradientTransform: "matrix(1 0 0 -1 0 13.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00381,
    style: {
      stopColor: "#FF638A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4634,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6426,
    style: {
      stopColor: "#A0DF39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8181,
    style: {
      stopColor: "#4AF06D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9406,
    style: {
      stopColor: "#15FB8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FF9A"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M53.9,0.9c0.1,0,0.3,0,0.4,0.1c0.1,0.1,0.1,0.2,0.1,0.4v9.4c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.2,0.1-0.4,0.1 c-0.1,0-0.2,0-0.3-0.1s-0.1-0.2-0.1-0.4V1.4c0-0.1,0-0.3,0.1-0.4C53.6,0.9,53.7,0.9,53.9,0.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.03134124,
    y1: 4.859,
    x2: 65.0313,
    y2: 5.6923,
    gradientTransform: "matrix(1 0 0 -1 0 13.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00381,
    style: {
      stopColor: "#FF638A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4634,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6426,
    style: {
      stopColor: "#A0DF39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8181,
    style: {
      stopColor: "#4AF06D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9406,
    style: {
      stopColor: "#15FB8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FF9A"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 53.9,
    cy: 7.6,
    r: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudiodrillzLogo);
export default __webpack_public_path__ + "static/media/AudiodrillzLogo.c76bc379.svg";
export { ForwardRef as ReactComponent };